module.exports = __webpack_public_path__ + "img/05_speaker3.7175bac1.png";